
import { mapGetters, mapMutations, mapActions } from 'vuex';
import * as api from '~/api/index';
import * as types from '~/types';

import ArticleAuthor from '~/components/article/article-author';
import HotArticle from '~/components/public/hot-article';
import AboutArticle from '~/components/public/about-article';
import AboutStock from '~/components/public/about-stock';
import AboutTopic from '~/components/public/about-topic';
import NavShare from '~/components/public/nav-share';
import NavLike from '~/components/public/nav-like';
import Comment from '~/components/public/comment';
import { formartRoute } from '~/utils/util';
// import articleBottomAds from '~/components/ad/article-bottom-ads';

export default {
  components: {
    Comment,
    NavShare,
    NavLike,
    ArticleAuthor,
    HotArticle,
    AboutStock,
    AboutArticle,
    AboutTopic,
    // articleBottomAds,
  },
  layout: 'details',
  validate({ params }) {
    // Must be a number
    return /^\d+$/.test(params.id);
  },
  async asyncData({ params, error, $axios }) {
    // eslint-disable-next-line no-console
    console.log('sever fetch post');
    try {
      let articleDetail = {};
      const id = params.id;
      const [articleDetailData, articleRelatedData] = await Promise.all([
        $axios(api.getArticleDetail({ id })),
        $axios(
          api.getArticleRelated({
            postId: id,
            count: 4,
          })
        ),
      ]);
      const reg = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      const reg1 = /<[^>]+>/gi;
      if (articleDetailData?.result) {
        articleDetail = articleDetailData.result;
      } else {
        throw new Error('帖子不存在' + params.id);
      }
      articleDetail.content = (articleDetail.content || '').replace(reg, '');
      if (articleDetail.remainWordNumber) {
        articleDetail.content =
          (articleDetail.content || '').replace(reg1, '') + '...';
      }
      /**
       * 缺少获取用户是否有关注该作者
       */
      // 获取相关股票的详细数据
      let stockCodeLists = [];
      let authorMoreArticle = {};
      const stocks = articleDetail.relatedStocks || [];
      // 如果没股票代码就别浪费感情请求接口了
      if (stocks?.length > 0) {
        const stockList = stocks.map(i => `${i.market}${i.code}`);
        const stockCodeDataLists = await $axios(
          api.getStocksDetails({
            stockCodes: stockList.join(','),
          })
        );
        stockCodeLists = stockCodeDataLists?.result ?? [];
      }

      if (articleDetail?.album || articleDetail?.column) {
        if (articleDetail?.album?.id) {
          authorMoreArticle = await $axios(
            api.getColumnArticlesList({ id: articleDetail.album.id })
          );
          if (authorMoreArticle?.result) {
            const vipArtciles = authorMoreArticle.result.map(
              item => item.vipArticle
            );

            if (vipArtciles && vipArtciles.lenth > 0) {
              authorMoreArticle.result = vipArtciles
                .filter(item => item.contentId !== articleDetail.id)
                .slice(0, 3);
            } else {
              authorMoreArticle.result = [];
            }
          }
        } else if (articleDetail?.column?.id) {
          authorMoreArticle = await $axios(
            api.getAuthorArticle({
              page: 1,
              count: 3,
              userId: articleDetail.column.id,
            })
          );
        }
      }

      return {
        postId: id,
        shareUrl: 'https://m.gelonghui.com/p/' + id,
        articleDetail,
        articleRelated: articleRelatedData?.result ?? [],
        authorMoreArticle: authorMoreArticle?.result ?? [],
        stockNews: [],
        stockCodeLists,
      };
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      error({ statusCode: 404, message: '文章不存在' });
    }
  },
  data() {
    return {
      navFixed: false,
    };
  },
  head() {
    return {
      title: `${this.articleDetail.title}-格隆汇`,
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          // content: keywords.join(",")
          content: `${this.articleDetail.title}`,
        },
        {
          hid: 'description',
          name: 'description',
          content:
            this.articleDetail && this.articleDetail.summary
              ? this.articleDetail.summary.slice(0, 76)
              : '',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: `https://www.gelonghui.com/p/${this.articleDetail.postId}`,
        },
        {
          rel: 'alternate',
          media: 'only screen and (max-width:640px)',
          href: `https://m.gelonghui.com/p/${this.articleDetail.postId}`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'vipInfo', 'isLogin']),
  },
  mounted() {
    this.dealInlineProductionPage();
  },
  methods: {
    ...mapMutations('user', [types.SHOW_LOGIN_FORM]),
    ...mapActions({
      createOrder: 'order/createOrder',
    }),
    dealInlineProductionPage() {
      if (this.articleDetail?.statistic?.isTrial) return;

      // 登录了未解锁则跳转inlineProductPage,比如挖股，黑金;
      if (
        this.articleDetail?.purchaseInfo?.inlineProductPage &&
        !this.articleDetail?.purchaseInfo?.unlockStatus
      ) {
        window.location.href = formartRoute(
          this.articleDetail?.purchaseInfo?.inlineProductPage
        );
      }
    },
    async getArticleDetail() {
      let articleDetail = {};
      const articleDetailData = await this.$axios(
        api.getArticleDetail({ id: this.postId })
      );
      const reg = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      if (articleDetailData && articleDetailData.result) {
        articleDetail = articleDetailData.result;
      }
      articleDetail.content = (articleDetail.content || '').replace(reg, '');
      const reg1 = /<[^>]+>/gi;
      if (articleDetail.remainWordNumber) {
        articleDetail.content =
          (articleDetail.content || '').replace(reg1, '') + '...';
      }
      // articleDetail.result.createDate = initTime(
      //   articleDetail.result.createDate * 1000
      // ).format('Y-M-D');
      this.articleDetail = articleDetail;
    },

    async like(id) {
      if (this.articleDetail.isLike) {
        await this.$axios(
          api.cancelLikePost({
            postId: id,
          })
        );
      } else {
        await this.$axios(
          api.likePost({
            postId: id,
          })
        );
      }
      this.getArticleDetail();
    },
    async collect(id) {
      if (this.articleDetail.isFav) {
        await this.$axios(
          api.delFavPost({
            postId: id,
            source: 'article',
          })
        );
      } else {
        await this.$axios(
          api.addFavPost({
            postId: id,
          })
        );
      }
      this.getArticleDetail();
    },
    async openMember() {
      if (!this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }

      // const articleNeed = this.articleDetail.vipTypes;
      let userViptype;
      if (!this.vipInfo.vipType) {
        userViptype = this.articleDetail.vipTypes[0];
      } else if (
        this.vipInfo.vipType === 'ultimate' ||
        this.vipInfo.vipType === 'platinum'
      ) {
        userViptype = 'ultimate';
      } else if (this.vipInfo.vipType === 'gold') {
        userViptype = this.articleDetail.vipTypes.includes(this.vipInfo.vipType)
          ? this.articleDetail.vipTypes[1]
          : this.articleDetail.vipTypes[0];
      }

      const goodList = await this.$axios(api.vipList());
      if (goodList && goodList.result && goodList.result.length > 0) {
        goodList.result.forEach(i => {
          if (i.vipType === userViptype) {
            this.$router.push({
              // /member/payment?type=platinum&gid=27
              path: '/member/payment',
              query: {
                type: i.vipType,
                gid: i.goodsId,
              },
            });
          }
        });
      }
      // this.$router.push('/member')
    },
    openOrder(specsId) {
      if (!this.isLogin) {
        // 未登录时间
        this[types.SHOW_LOGIN_FORM]();
        return false;
      } else {
        this.createOrder({
          specsId,
        });
      }
    },
  },
};
